// Garde de la page de consentement du connecteur Claude (PLAN_CONNECTEUR_MCP.md, lot 1e) : comme ProtectedRoute,
// mais retient la demande pour revenir après le login (sinon l'utilisateur retombe sur l'accueil et la connexion
// Claude est perdue). `user`/`loading` viennent d'App.js en props : aucun import d'App (cycle), testable seule.
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setPostLoginRedirect } from "../lib/authRedirect";
import { CONSENT_REQ_RE, consentPath, consentReqOf } from "../lib/claudeConnector";

export default function ConsentRoute({ user, loading, children }) {
  const location = useLocation();
  const req = consentReqOf(location);

  useEffect(() => {
    if (!loading && !user && CONSENT_REQ_RE.test(req)) setPostLoginRedirect(consentPath(req));
  }, [loading, user, req]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center" data-testid="consent-route-loading">
        <div className="spinner w-8 h-8"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
